import CustomData from "pages/_components/CustomData/CustomData";
import CustomText from "pages/_components/CustomText/CustomText";
import FormattedAmount from "pages/_components/FormattedAmount";
import GridTable from "pages/_components/GridTable/GridTable";
import Image from "pages/_components/Image";
import { bool, instanceOf } from "prop-types";
import React from "react";
import * as i18n from "util/i18n";

const BillInfoSummary = ({ bills, isSummaryPage, isDesktop }) => {
    const totalAmount = bills?.reduce((sum, item) => sum + item.saldoAceptado, 0);

    return (
        <div className="box box-border-soft soft-inform-control">
            <GridTable>
                {isDesktop && (
                    <GridTable.Container columns={2} rows={1} className="billInfo-summary-multiple">
                        <GridTable.Data columnStart={1} rowStart={1}>
                            {isSummaryPage ? (
                                <CustomData
                                    titleText="creditBill.quantity.label"
                                    titleTextType="I18N"
                                    valueText={` ${bills?.length} ${i18n.get("credit.bills.invoices")}`}
                                    valueTextType="TEXT"
                                />
                            ) : (
                                <div className="recipt-image-length">
                                    <Image src="images/selectedRecipts.svg" alt="icon" className="icon-xlarge" />
                                    <CustomText
                                        text={` ${bills?.length} ${i18n.get("credit.bills.invoices")}`}
                                        textType="TEXT"
                                    />
                                </div>
                            )}
                        </GridTable.Data>
                        <GridTable.Data columnStart={2} rowStart={1}>
                            <CustomData
                                titleText="credit.bills.modify.total.amount"
                                titleTextType="I18N"
                                valueText={<FormattedAmount currency="ARS" quantity={totalAmount} />}
                                valueTextType="TEXT"
                            />
                        </GridTable.Data>
                    </GridTable.Container>
                )}
                {!isDesktop && (
                    <>
                        <GridTable.Container columns={2} rows={1} className="billInfo-summary-multiple">
                            <div className="credit-bills-recipt">
                                <GridTable.Data columnStart={1} rowStart={1}>
                                    {isSummaryPage ? (
                                        <CustomData
                                            titleText="creditBill.quantity.label"
                                            titleTextType="I18N"
                                            valueText={` ${bills?.length} ${i18n.get("credit.bills.invoices")}`}
                                            valueTextType="TEXT"
                                        />
                                    ) : (
                                        <div className="recipt-image-length">
                                            <Image
                                                src="images/selectedRecipts.svg"
                                                alt="icon"
                                                className="icon-xlarge"
                                            />
                                            <CustomText
                                                text={` ${bills?.length} ${i18n.get("credit.bills.invoices")}`}
                                                textType="TEXT"
                                            />
                                        </div>
                                    )}
                                </GridTable.Data>
                            </div>
                            <div className="credit-bills-divider" />
                            <div className="credit-bills-amount">
                                <GridTable.Data columnStart={2} rowStart={1}>
                                    <CustomData
                                        titleText="credit.bills.modify.total.amount"
                                        titleTextType="I18N"
                                        valueText={<FormattedAmount currency="ARS" quantity={totalAmount} />}
                                        valueTextType="TEXT"
                                    />
                                </GridTable.Data>
                            </div>
                        </GridTable.Container>
                    </>
                )}
            </GridTable>
        </div>
    );
};

BillInfoSummary.propTypes = {
    bills: instanceOf(Array).isRequired,
    isSummaryPage: bool,
    isDesktop: bool.isRequired,
};

BillInfoSummary.defaultProps = {
    isSummaryPage: false,
};

export default BillInfoSummary;
